import React from 'react';
import { AlarmClockIcon } from 'lucide-react';
import { CtaButton } from '../CtaButton';
import { PriceBlock } from '../PriceBlock';
import { useCountdown } from '../../hooks/useCountdown';
import { launchOffer, PRODUCT_NAME } from '../../data/salesContent';
export function OfferSection() {
  const {
    hours,
    minutes,
    seconds
  } = useCountdown(launchOffer.hours);
  const units = [{
    value: hours,
    label: 'HS'
  }, {
    value: minutes,
    label: 'MIN'
  }, {
    value: seconds,
    label: 'SEG'
  }];
  return <section className="bg-surface px-5 py-20 md:py-28" aria-label="Precio especial" data-id="element-157" data-mp="1owyynvvn6yw">
      <div className="mx-auto max-w-3xl overflow-hidden rounded-3xl border-2 border-accent bg-canvas" data-id="element-158" data-mp="3sxu9ip7c8xb3">
        <div className="border-b border-line bg-raised px-6 py-10 text-center md:px-12" data-id="element-159" data-mp="3nz0wexvyr8bg">
          <p className="flex items-center justify-center gap-2 text-base font-extrabold uppercase tracking-wide text-accent md:text-xl" data-id="element-160" data-mp="3ixjzfdglo605">
            <AlarmClockIcon className="h-5 w-5 shrink-0 md:h-6 md:w-6" aria-hidden="true" data-id="element-161" data-mp="3ez4f5hbwlbqf" />
            Precio especial — termina en:
          </p>
          <div className="mt-8 flex items-start justify-center gap-2 md:gap-4" role="timer" aria-live="off" data-id="element-162" data-mp="1fj0jj6xulz1x">
            {units.map((u, i) => <React.Fragment key={u.label} data-id="element-163" data-mp="10vfgte4vy1uj" data-mpi={i}>
                <div className="flex w-20 flex-col items-center rounded-xl border border-line bg-canvas py-4 md:w-28 md:py-5" data-id="element-164" data-mp="15so1bldiahyy">
                  <span className="text-4xl font-black tabular-nums leading-none text-ink md:text-6xl" data-id="element-165" data-mp="1ti8hxxm6t352">{String(u.value).padStart(2, '0')}</span>
                  <span className="mt-2 text-xs font-bold tracking-widest text-accent md:text-sm" data-id="element-166" data-mp="1yfihw777cx75">{u.label}</span>
                </div>
                {i < units.length - 1 && <span className="pt-3 text-4xl font-black text-accent md:pt-4 md:text-5xl" aria-hidden="true" data-id="element-167" data-mp="1oidvq7dcx1qc">
                    :
                  </span>}
              </React.Fragment>)}
          </div>
          <p className="mx-auto mt-8 max-w-md text-base text-muted md:text-lg" data-id="element-168" data-mp="d51mfgytvqws">
            Aprovechá el acceso al {PRODUCT_NAME} al precio actual.
          </p>
        </div>

        <div className="px-6 py-10 text-center md:px-12" data-id="element-169" data-mp="2arawoa48skpx">
          <p className="text-2xl font-black uppercase tracking-tight text-ink md:text-3xl" data-id="element-170" data-mp="2atxb8tpjw0hn">Todo en un solo sistema</p>
          <p className="mt-2 text-base font-semibold uppercase tracking-widest text-accent md:text-lg" data-id="element-171" data-mp="212112ka6wjx2">5 volúmenes + 5 bonos prácticos</p>
          <div className="mt-6" data-id="element-172" data-mp="1x1h3jflpfeae">
            <PriceBlock data-id="element-173" data-mp="1wycti1lk5obt" />
          </div>
          <div className="mt-8" data-id="element-174" data-mp="1s0th778f7lmi">
            <CtaButton data-id="element-175" data-mp="1s0jqtijgrcga">Quiero dejar de preparar todo desde cero</CtaButton>
          </div>
        </div>
      </div>
    </section>;
}